<template>
  <div class="e-accordion-content">
    <slot />
  </div>
</template>
